/**
 * @description: 打开修改计划创意弹窗
 * @param {*} rowIndex // 单条修改时的行索引
 * @return {*}
 */
export function onCreativeModify(rowIndex) {
  // 点击单行时设置check状态
  if (!Object.is(Number(rowIndex), NaN)) {
    this.tableData = this.tableData.map((row, index) => {
      return { ...row, creativeCheck: index === rowIndex }
    })
  } else {
    if (!this.tableData.some((row) => row.creativeCheck)) {
      return this.$Message.warning('请选择修改行')
    }
  }

  this.modal.showGlobalCreativeModify = true
}

/**
 * @description: 更换创意确认
 * @return {*}
 */
export function onCreativeModifyConfirm(creativeItem) {
  if (creativeItem) {
    this.tableData = this.tableData.map((row) => {
      if (row.creativeCheck) {
        const newRow = { ...row, creative: { ...creativeItem } }
        return newRow
      }

      return row
    })
  }

  this.onModifyModalCancel()
}
